import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { AiFillCheckCircle } from "react-icons/ai";
import { FaBold, FaItalic } from "react-icons/fa";

import Input from "../Input";
import classes from "./TextPopOverchildren.module.css";
import TextArea from "../TextArea";
import { rangeSliderStyles } from "../../handlers/helperFunctions";

const TextPopOverchildren = ({
  label,
  getter,
  setter,
  galleryArray = [],
  isDescription = false,
  bgEditable = false,
  title = true,
  gradient = false,
  hideGradient = false, // correct this
  backgroundColor = false,
  showOutline = false,
}) => {
  // handleGalleryImageSelect
  const handleGalleryImageSelect = (selectedImage) => {
    if (selectedImage === getter?.url) return;

    setter((p) => ({ ...p, url: selectedImage }));
  };

  return (
    <div className={classes?.container}>
      <div className={classes?.group}>
        <FormControlLabel
          control={<Checkbox defaultChecked />}
          label={`Show/Hide ${label}`}
          onChange={(e) =>
            setter((p) => ({ ...p, isVisible: e?.target?.checked }))
          }
          checked={getter?.isVisible}
        />
      </div>
      <div className={`${classes?.group} ${classes?.fontStylerContainer}`}>
        <div
          onClick={() => {
            if (getter?.fontWeight) setter((p) => ({ ...p, fontWeight: null }));
            else setter((p) => ({ ...p, fontWeight: "bold" }));
          }}
          className={`${classes?.fontStyler} ${
            getter?.fontWeight && classes?.activeFontStyler
          }`}
        >
          <FaBold />
        </div>
        <div
          onClick={() => {
            if (getter?.fontStyle) setter((p) => ({ ...p, fontStyle: null }));
            else setter((p) => ({ ...p, fontStyle: "italic" }));
          }}
          className={`${classes?.fontStyler} ${
            getter?.fontStyle && classes?.activeFontStyler
          }`}
        >
          <FaItalic />
        </div>
      </div>
      {title && (
        <div className={classes?.group}>
          <label>{label}</label>
          {!isDescription && (
            <Input
              placeholder={`Enter ${label}`}
              value={getter?.text}
              setter={(e) => setter((p) => ({ ...p, text: e }))}
            />
          )}
          {isDescription && (
            <TextArea
              value={getter?.text}
              setter={(e) => setter((p) => ({ ...p, text: e }))}
              rows={7}
            />
          )}
        </div>
      )}
      <div className={classes?.group}>
        <label>Select Color</label>
        <Input
          type={"color"}
          placeholder={"Enter Color Code"}
          value={getter?.color}
          setter={(e) => setter((p) => ({ ...p, color: e }))}
          inputStyle={{ height: "40px" }}
        />
      </div>
      {bgEditable && (
        <>
          <div className={classes?.group}>
            <label>Select Transparency</label>
            <Input
              type={"range"}
              min={0}
              max={1}
              step={0.01}
              placeholder={"Select transparency"}
              value={getter?.transparency}
              setter={(e) => setter((p) => ({ ...p, transparency: e }))}
              inputStyle={rangeSliderStyles}
            />
          </div>
          <div className={classes?.group}>
            <label>Select Blur</label>
            <Input
              type={"range"}
              min={0}
              max={20}
              step={1}
              placeholder={"Select Blur"}
              value={getter?.blur}
              setter={(e) => setter((p) => ({ ...p, blur: e }))}
              inputStyle={rangeSliderStyles}
            />
          </div>
          <div className={classes?.group}>
            <label>Select Outline</label>
            <Input
              type={"range"}
              min={0}
              max={1}
              step={0.01}
              placeholder={"Select Outline"}
              value={getter?.outline}
              setter={(e) => setter((p) => ({ ...p, outline: e }))}
              inputStyle={rangeSliderStyles}
            />
          </div>
          <div className={classes?.group}>
            <label>Select Background Color</label>
            <Input
              type={"color"}
              placeholder={"Enter Color Code"}
              value={getter?.bgColor}
              // setter={(e) => setter((p) => ({ ...p, bgColor: e }))}
              setter={(e) => console.log(e)}
              inputStyle={{ height: "40px" }}
            />
          </div>
        </>
      )}
      {galleryArray?.length !== 0 && (
        <div className={classes?.group}>
          <label>Select Card Back Image</label>
          <div className={classes?.galleryContainer}>
            {galleryArray?.map((e) => {
              return (
                <div
                  className={classes?.galleryItem}
                  onClick={handleGalleryImageSelect.bind(this, e)}
                >
                  <img src={e} key={e} />
                  {e === getter?.url && (
                    <AiFillCheckCircle
                      className={classes?.galleryItemSelected}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      )}
      {gradient && (
        <>
          <div className={classes?.group}>
            <label>Select First Gradient Color</label>
            <Input
              type={"color"}
              placeholder={"Enter Color Code"}
              value={getter?.gradientColor1}
              setter={(e) => setter((p) => ({ ...p, gradientColor1: e }))}
              inputStyle={{ height: "40px" }}
            />
          </div>
          {hideGradient && (
            <>
              <div className={classes?.group}>
                <label>Select Second Gradient Color</label>
                <Input
                  type={"color"}
                  placeholder={"Enter Color Code"}
                  value={getter?.gradientColor2}
                  setter={(e) => setter((p) => ({ ...p, gradientColor2: e }))}
                  inputStyle={{ height: "40px" }}
                />
              </div>
              <div className={classes?.group}>
                <label>Select Upper gradient Spread</label>
                <Input
                  type={"range"}
                  min={1}
                  max={100}
                  step={1}
                  placeholder={"Select..."}
                  value={getter?.gradient1Spread}
                  setter={(e) => setter((p) => ({ ...p, gradient1Spread: e }))}
                  inputStyle={rangeSliderStyles}
                />
              </div>
              <div className={classes?.group}>
                <label>Select Bottom gradient Spread</label>
                <Input
                  type={"range"}
                  min={1}
                  max={100}
                  step={1}
                  placeholder={"Select..."}
                  value={getter?.gradient2Spread}
                  setter={(e) => setter((p) => ({ ...p, gradient2Spread: e }))}
                  inputStyle={rangeSliderStyles}
                />
              </div>
            </>
          )}
        </>
      )}
      {backgroundColor && (
        <div className={classes?.group}>
          <label>Background Color</label>
          <Input
            type={"color"}
            placeholder={"Enter Color Code"}
            value={getter?.bgColor}
            setter={(e) => setter((p) => ({ ...p, bgColor: e }))}
            inputStyle={{ height: "40px" }}
          />
        </div>
      )}
      {showOutline && (
        <div className={classes?.group}>
          <label>Outline Color</label>
          <Input
            type={"color"}
            placeholder={"Enter Color Code"}
            value={getter?.outline}
            setter={(e) => setter((p) => ({ ...p, outline: e }))}
            inputStyle={{ height: "40px" }}
          />
        </div>
      )}
    </div>
  );
};

export default TextPopOverchildren;
